import React, { useState, useEffect } from "react";
import "./CreatePost.css";

const API_URL = process.env.REACT_APP_API_URL || "http://localhost/cool/my-app/backend";

export default function EditNewsPost({ post, onClose, onUpdated }) {
  const [title, setTitle] = useState(post.title || "");
  const [content, setContent] = useState(post.content || "");
  const [category, setCategory] = useState(post.category || "General");
  const [existingMedia, setExistingMedia] = useState(post.media || []);
  const [removedMediaIds, setRemovedMediaIds] = useState([]);
  const [newFiles, setNewFiles] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setTitle(post.title || "");
    setContent(post.content || "");
    setCategory(post.category || "General");
    setExistingMedia(post.media || []);
    setRemovedMediaIds([]);
    setNewFiles([]);
  }, [post]);

  const handleRemoveExisting = (mediaId) => {
    setRemovedMediaIds((prev) => [...prev, mediaId]);
    setExistingMedia((prev) => prev.filter((m) => m.id !== mediaId));
  };

  const handleNewFiles = (e) => {
    const selected = Array.from(e.target.files);
    setNewFiles((prev) => {
      const existing = new Set(prev.map((f) => f.name + f.size));
      return [...prev, ...selected.filter((f) => !existing.has(f.name + f.size))];
    });
  };

  const handleDrop = (e) => {
    e.preventDefault();
    const dropped = Array.from(e.dataTransfer.files);
    setNewFiles((prev) => {
      const existing = new Set(prev.map((f) => f.name + f.size));
      return [...prev, ...dropped.filter((f) => !existing.has(f.name + f.size))];
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!title.trim() || !content.trim()) {
      alert("Title and content are required.");
      return;
    }

    setLoading(true);

    const formData = new FormData();
    formData.append("post_id", post.id);
    formData.append("title", title);
    formData.append("category", category);
    formData.append("content", content);
    formData.append("removed_media_ids", JSON.stringify(removedMediaIds));
    newFiles.forEach((file) => formData.append("media[]", file));

    try {
      const res = await fetch(`${API_URL}/update_newspost.php`, {
        method: "POST",
        body: formData,
      });
      const result = await res.json();
      if (result.success) {
        alert("Post updated successfully!");
        if (onUpdated) onUpdated();
        onClose();
      } else {
        alert(result.message || "Failed to update post.");
      }
    } catch (err) {
      console.error("Error updating post:", err);
      alert("An error occurred while updating the post.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="modal">
      <div className="modal-content" onDragOver={(e) => e.preventDefault()}>
        <button className="close-btn" onClick={onClose}>&times;</button>

        <h2 className="modal-title">Edit News Post</h2>

        <input
          type="text"
          className="input-title"
          placeholder="Title"
          value={title}
          onChange={(e) => setTitle(e.target.value)}
        />

        <textarea
          className="input-textarea"
          placeholder="What's on your mind?"
          value={content}
          onChange={(e) => setContent(e.target.value)}
        />

        <select
          className="input-select"
          value={category}
          onChange={(e) => setCategory(e.target.value)}
        >
          <option>General</option>
          <option>Announcement</option>
          <option>Event</option>
        </select>

        {/* Existing media */}
        {existingMedia.length > 0 && (
          <div style={{ marginTop: "10px" }}>
            <p style={{ fontSize: "13px", color: "#555", marginBottom: "6px" }}>
              Current media (click ✕ to remove):
            </p>
            <div className="preview-container">
              {existingMedia.map((m) => (
                <div key={m.id} className="preview-item">
                  {m.type === "video" ? (
                    <video src={m.url} className="preview-thumb" controls />
                  ) : (
                    <img src={m.url} alt="media" className="preview-thumb" />
                  )}
                  <button
                    className="remove-btn"
                    onClick={() => handleRemoveExisting(m.id)}
                  >
                    ✕
                  </button>
                </div>
              ))}
            </div>
          </div>
        )}

        {/* New media upload */}
        <div
          className="upload-box"
          onDragOver={(e) => e.preventDefault()}
          onDrop={handleDrop}
        >
          <input
            type="file"
            multiple
            accept="image/*,video/*"
            onChange={handleNewFiles}
            style={{ display: "none" }}
            id="editMediaInput"
          />
          <label htmlFor="editMediaInput" className="click-text">
            Drag & drop or click to add new photos/videos
          </label>

          {newFiles.length > 0 && (
            <div className="preview-container">
              {newFiles.map((file, i) => (
                <div key={i} className="preview-item">
                  {file.type.startsWith("image/") ? (
                    <img
                      src={URL.createObjectURL(file)}
                      alt="preview"
                      className="preview-thumb"
                    />
                  ) : (
                    <video
                      src={URL.createObjectURL(file)}
                      className="preview-thumb"
                      controls
                    />
                  )}
                  <button
                    className="remove-btn"
                    onClick={() =>
                      setNewFiles((prev) => prev.filter((_, idx) => idx !== i))
                    }
                  >
                    ✕
                  </button>
                </div>
              ))}
            </div>
          )}
        </div>

        <div className="button-row">
          <button className="cancel-btn" onClick={onClose}>
            Cancel
          </button>
          <button className="post-btn" onClick={handleSubmit} disabled={loading}>
            {loading ? "Saving..." : "Save Changes"}
          </button>
        </div>
      </div>
    </div>
  );
}
